const hosturl = './img/';
const ex = './img/ex/';
const logino = './img/logino/';
const preview = './img/preview/'
const icon = './img/summary_icon/'

export default {
    /* 登录页*/
    loginbg: require(`${hosturl}bg.png`),
    logo: require(`${hosturl}logo.png`),
    logo2: require(`${hosturl}logo2.png`),
    logobg2: require(`${hosturl}loginbg2.png`),

    /* 公共 */
    commonNoData: require(`${hosturl}noData.png`),
    common404: require(`${hosturl}404.png`),
    common403: require(`${hosturl}403.png`),
    common500: require(`${hosturl}500.png`),

    // 头部
    // screen: require(`${hosturl}screen.svg`),
    userAvatar: require(`${hosturl}user-avatar.png`),
    whiteLogo: require(`${hosturl}white-logo.png`),
    // blueLogo: require(`${hosturl}blue-logo.png`),
    headerLogo: require(`${hosturl}logos.png`),

    logo2: require(`${hosturl}logo2.png`),

    exa1: require(`${ex}a1.jpg`),

    // preview
    zoomIn: require(`${preview}zoomIn.svg`),
    zoomOut: require(`${preview}zoomOut.svg`),
    original: require(`${preview}original.svg`),
    originalRatio: require(`${preview}originalRatio.svg`),
    rotateLeft: require(`${preview}rotateLeft.svg`),
    rotateRight: require(`${preview}rotateRight.svg`),
    download: require(`${preview}download.svg`),

    //icon
    sumicon0:require(`${icon}0.png`),
    sumicon1:require(`${icon}1.png`),
    sumicon2:require(`${icon}2.png`),
    sumicon3:require(`${icon}3.png`),
    sumicon4:require(`${icon}4.png`),
    sumicon5:require(`${icon}5.png`),
    sumicon6:require(`${icon}6.png`),
}